(function () {
  if (window.__sineadCircleDingDongInit) return;
  window.__sineadCircleDingDongInit = true;

  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (prefersReducedMotion) return;

  var selector = '.sinead-concern-circles-grid .sinead-circle-link, .sinead-support-bubble-cluster .sinead-circle-link';
  var lastScrollY = window.scrollY || 0;
  var scrollDirection = 'down';

  function updateScrollDirection() {
    var currentY = window.scrollY || 0;
    scrollDirection = currentY >= lastScrollY ? 'down' : 'up';
    lastScrollY = currentY;
  }

  function initializeCircleIndexes() {
    var sectionSelector = '.sinead-concern-circles-grid, .sinead-support-bubble-cluster';
    var sections = document.querySelectorAll(sectionSelector);

    sections.forEach(function (section) {
      var circles = section.querySelectorAll('.sinead-circle-link');
      circles.forEach(function (circle, index) {
        circle.dataset.dingdongIndex = String(index);
      });
    });
  }

  function animateCircleIn(circle) {
    var directionClass = scrollDirection === 'up' ? 'is-entering-up' : 'is-entering-down';
    var staggerIndex = Number(circle.dataset.dingdongIndex || 0);
    var delayMs = Math.min(staggerIndex, 8) * 65;

    circle.style.setProperty('--sinead-dingdong-delay', delayMs + 'ms');
    circle.classList.remove('is-visible', 'is-entering-up', 'is-entering-down');
    void circle.offsetWidth;
    circle.classList.add('is-visible', directionClass);
  }

  function observeCircles() {
    var circles = document.querySelectorAll(selector);
    if (!circles.length) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          var circle = entry.target;

          if (entry.isIntersecting) {
            animateCircleIn(circle);
            return;
          }

          circle.classList.remove('is-visible', 'is-entering-up', 'is-entering-down');
        });
      },
      {
        threshold: 0.32,
        rootMargin: '-10% 0px -10% 0px',
      }
    );

    circles.forEach(function (circle) {
      observer.observe(circle);
    });
  }

  document.body.classList.add('sinead-dingdong-ready');
  initializeCircleIndexes();
  observeCircles();

  window.addEventListener('scroll', updateScrollDirection, { passive: true });
  document.addEventListener('shopify:section:load', function () {
    initializeCircleIndexes();
  });
})();
